import { AvailableSlots } from 'types/app/availableSlots';

export const AvailableSlotsState: AvailableSlots = [];
